import { CaseReducer, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AuthResponse } from '../schemas/auth.schemas';

interface PublicAuthState {
  access: undefined;
  refresh: undefined;
}

type AuthState = AuthResponse['tokens'] | PublicAuthState;

const initialState: AuthState = {
  access: undefined,
  refresh: undefined,
};

const removeTokensReducer: CaseReducer<AuthState> = () => {
  return initialState;
};

export const userSlice = createSlice({
  name: 'auth',
  initialState: initialState as AuthState,
  reducers: {
    removeTokens: removeTokensReducer,
    setTokens: (state, { payload }: PayloadAction<AuthResponse>) => {
      if (state && payload.tokens) {
        state.access = payload.tokens.access;
        state.refresh = payload.tokens.refresh;
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const { removeTokens, setTokens } = userSlice.actions;

export default userSlice.reducer;
